import React, { useState, useEffect, useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";
import tw from "tailwind-styled-components";
import Table from "../../Components/Sales/Table";
import {
  BoxContainer,
  BoxTitle,
  BoxHead,
  Underline,
  FilterTableWrapper,
  FilterWrapper,
  FilterWrapperWithSearch,
} from "../../Components/Styles/PageStyles";
import AddLead from "../../Components/Sales/AddLead";
import EditLead from "../../Components/Sales/EditLead";
import SummaryCards from "../../Components/Sales/SummaryCard";
import { Form, Formik } from "formik";
import { toast } from "react-toastify";

import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useLocation, useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import axios from "axios";
import Config from "../../Config";
import Loading from "../../Components/Loading";
import NotFoundModel from "../../Components/NotFoundModel";
import { SummarySkeletonLoading } from "../../Components/SkeletonLoading";
import SearchFilterBox from "../../Components/SearchFilterBox";
import DateRange from "../../Components/DateRange";
import LinkUnlink from "../../Components/Sales/LinkUnlink";
import ViewLead from "../../Components/Sales/ViewLead";
import AssignStaff from "../../Components/Sales/AssignStaff";
import SideModal from "../../Components/SideModal";
import SelectProperty from "../../Components/AddTenant/SelectProperty";
import DeleteLead from "../../Components/Sales/DeleteLead";
import PropertiesFilterDropdown from "../../Components/PropertiesFilterDropdown";
import FilterModal from "../../Components/Sales/FilterModal";
import { Select_Location } from "../../Redux/actions";
import { IoFilter } from "react-icons/io5";

const Leads = () => {
  const locationState = useLocation();
  const navState = locationState.state || {};
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const searchOptions = [
    { label: "Mobile", value: 1 },
    { label: "Name", value: 2 },
  ];
  const { t, i18n } = useTranslation();
  const [isShowEditLead, setIsShowEditLead] = useState(false);
  const [isShowAddLead, setIsShowAddLead] = useState(false);
  const [isShowDeleteLead, setIsShowDeleteLead] = useState(false);
  const [key, setKey] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const user = useSelector((state) => state.UserReducer.user);
  const [viewDetail, setViewDetail] = useState(false);
  // const location = useLocation();
  const [selectedData, setSelectedData] = useState(null);
  const [tempData, setTempData] = useState(null);
  // const [filterValue, setFilterValue] = useState("");
  // const [filter, setFilter] = useState("");
  const [masterData, setMasterData] = useState();
  const [linkProperty, setLinkProperty] = useState(false);
  const [isAssignStaff, setIsAssignStaff] = useState(false);
  const [apiData, setApiData] = useState();
  const [staffList, setStaffList] = useState();
  const [filterType, setFilterType] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [showProperty, setShowProperty] = useState(false);
  const [selectedTenant, setSelectedTenant] = useState(null);
  const properties = useSelector((state) => state.PropertyReducer.property);
  const property = useSelector(
    (state) => state.SelectPropertyReducer.selectProperty
  );
  const location = useSelector(
    (state) => state.SelectLocationReducer.selectLocation
  );
  // const [selectedProperty, setSelectedProperty] = useState(property);
  const [selectedProperty, setSelectedProperty] = useState(() => {
    if (navState?.propId !== undefined && navState?.propId !== null) {
      const id = Number(navState.propId);
      const matched = properties?.find((p) => p.id === id);
      return matched ?? { id };
    }
    return property;
  });
  const [filterValue, setFilterValue] = useState("");
  const [filter, setFilter] = useState({
    staffFilters: "",
    sourceFilters: "",
    locationFilters: "",
  });
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const [activeFilter, setActiveFilter] = useState({
    value: "",
    label: "",
    title: "",
  });
  const parseFilterValue = (filterValue) => {
    if (!filterValue) return null;

    try {
      return JSON.parse(filterValue);
    } catch (error) {
      return filterValue;
    }
  };
  const formatFilterForDisplay = useCallback((parsedFilter) => {
    if (!parsedFilter?.selectedFilters) return null;

    const { selectedFilters } = parsedFilter;
    const filterCount =
      (selectedFilters.staff?.length || 0) +
      (selectedFilters.source?.length || 0) +
      (selectedFilters.locations?.length || 0);

    return {
      value: JSON.stringify(selectedFilters),
      label: `Filter (${filterCount})`,
      title: `Multi-Filter: ${filterCount} applied`
    };
  }, []);
  const createLocationFilterObject = useCallback((location) => {
    if (!location || !location.id || location.id === 0) return null;

    return {
      selectedFilters: {
        locations: [{
          value: location.id.toString(),
          label: location.name || `Location ${location.id}`
        }]
      }
    };
  }, []);

  const updateFilterForLocation = useCallback((location) => {
    if (!location || !location.id || location.id === 0) {
      setFilter(prev => ({
        ...prev,
        locationFilters: ''
      }));
      setFilterValue("");
      setActiveFilter({ value: "", label: "", title: "" });
      return;
    }

    const locationFilter = createLocationFilterObject(location);

    if (locationFilter) {
      setFilter(prev => ({
        ...prev,
        locationFilters: location.id.toString()
      }));

      setFilterValue(JSON.stringify(locationFilter.selectedFilters));

      const formattedFilter = formatFilterForDisplay(locationFilter);
      if (formattedFilter) {
        setActiveFilter(formattedFilter);
      }
    }
  }, [createLocationFilterObject, formatFilterForDisplay]);

  const [summary, setSummary] = useState({
    totalLeads: 0,
    newLeads: 0,
    followUpLeads: 0,
    visitedLeads: 0,
    convertedLeads: 0,
  });
  // const property = useSelector(
  //   (state) => state.SelectPropertyReducer.selectProperty
  // );

  const [startDate, setStartDate] = useState(
    moment().subtract(1, "year").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );

  const propertyList = useSelector((state) => state.PropertyReducer.property);

  const initialValues = {
    name: "",
    propertyName: "",
    filterVal: filterValue,
    startDate: moment(new Date()).subtract(7, "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
  };

  const fetchFunction = async () => {
    const params = new URLSearchParams();

    params.append("startDate", startDate);
    params.append("endDate", endDate);

    if (selectedProperty?.id) {
      params.append("propFilters", selectedProperty.id);
    }

    if (searchQuery) {
      params.append("s", searchQuery);
    }

    if (filterType) {
      params.append("t", filterType);
    }

    if (filter?.staffFilters) {
      params.append("staffFilters", filter.staffFilters);
    }

    if (filter?.sourceFilters) {
      params.append("sourceFilters", filter.sourceFilters);
    }

    if (filter?.locationFilters) {
      params.append("locationFilters", filter.locationFilters);
    }

    const response = await axios.get(
      `${Config.apiUrl}/lead/list/web?${params.toString()}`,
      {
        headers: {
          authorization: `Bearer ${user.token}`,
          "Content-Type":
            "application/x-www-form-urlencoded; charset=UTF-8",
        },
      }
    );

    return response.data;
  };

  const getSuccess = (res) => {
    //if (res.isSuccess === false) error = true;
    if (res?.isSuccess === false) {
      toast.error(res?.msg || "Unable to load leads");
      setApiData([]);
       setMasterData([]);
      setStaffList([]);
      setSummary({
        totalLeads: 0,
        newLeads: 0,
        followUpLeads: 0,
        visitedLeads: 0,
        convertedLeads: 0,
      });
      return;
    }
    else {
      setApiData(res?.data);
      setSummary(res?.summary);
      setMasterData(res?.data);
      setStaffList(res?.staffList);
      setIsFocused(true);
    }
  };

  const getError = (error) => {

    if (error?.response?.status === 401 || error?.response?.status === 403) {
      navigate("/no-access");
      return;
    }

    toast.error(
      error?.response?.data?.msg ||
      error?.message ||
      "Unable to load leads"
    );
  };

  const {
    isLoading: isLoading,
    mutate: getListMutate,
    error,
    data,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    const handler = setTimeout(() => {
      getListMutate();
    }, 100);

    return () => clearTimeout(handler);
  }, [
    startDate,
    endDate,
    selectedProperty?.id,
    searchQuery,
    filterType,
    filter?.staffFilters,
    filter?.sourceFilters,
    filter?.locationFilters,
  ]);

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setFilterType("");
    setSearchQuery("");
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    // const handler = setTimeout(() => {
    //   getListMutate();
    // }, 200);
    // return () => {
    //   clearTimeout(handler);
    // };
  };

  const handleFilterChange = (values) => {

    setFilterType(values.filterType);
    setSearchQuery(values.searchQuery);
    // setSelectedId(null);
    const locationFilterValue = location && location.id && location.id !== 0 ? location.id.toString() : '';
    setFilter({
      staffFilters: '',
      sourceFilters: '',
      locationFilters: locationFilterValue

    });
    if (location && location.id && location.id !== 0) {
      const locationFilter = createLocationFilterObject(location);
      if (locationFilter) {
        setFilterValue(JSON.stringify(locationFilter.selectedFilters));
        const formattedFilter = formatFilterForDisplay(locationFilter);
        if (formattedFilter) {
          setActiveFilter(formattedFilter);
        }
      }
    } else {
      setFilterValue("");
      setActiveFilter({ value: "", label: "", title: "" });
    }
  };

  const onApplyFilter = (selectedFilters) => {
    const staffFilters = selectedFilters.staff.map(f => f.value).join(',') || '';
    const sourceFilters = selectedFilters.source.map(f => f.value).join(',') || '';
    let locationFiltersArray = [...selectedFilters.locations];
    const hasLocationFilters = locationFiltersArray.length > 0;

    if (location && location.id && location.id !== 0) {
      const locationExists = locationFiltersArray.some(f => f.value === location.id.toString());
      if (!locationExists) {
        locationFiltersArray.push({
          value: location.id.toString(),
          label: location.name || `Location ${location.id}`
        });
      }
    }

    const locationFilters = locationFiltersArray.map(f => f.value).join(',') || '';

    const formattedFilter = formatFilterForDisplay({
      selectedFilters: {
        ...selectedFilters,
        locations: locationFiltersArray
      }
    });

    setFilter({
      staffFilters,
      sourceFilters,
      locationFilters
    });

    setActiveFilter(formattedFilter || {
      value: JSON.stringify(selectedFilters),
      label: "Custom Filter",
      title: "Multi-Filter"
    });

    setFilterValue(JSON.stringify(selectedFilters));
    setIsFilterOpen(false);
    setFilterType("");
    setSearchQuery("");
    if (hasLocationFilters) {
      setSelectedProperty({ id: 0, name: "All Properties", gId: "KIPINN", type: 0, tenantPreference: 3, tenantCount: 634, tenantPreference: 3, type: 0 });
    }
  };

  const handleClearFilters = () => {
    // setSelectedId(null)
    setActiveFilter({ value: "", label: "", title: "" });
    setFilterValue("");
    setFilter({
      staffFilters: '',
      sourceFilters: '',
      locationFilters: '',
    });
    setFilterType("");
    setSearchQuery("");
    setIsFilterOpen(false);
    dispatch(Select_Location({ id: 0, name: "All Locations", clientId: 0 }));
  };
  const panelRef = useRef(null);
  const btnRef = useRef(null);

  useEffect(() => {
    if (!isFilterOpen) return;
    const onKey = (e) => {
      if (e.key === "Escape") setIsFilterOpen(false);
    };
    const onClickOutside = (e) => {
      if (
        panelRef.current &&
        !panelRef.current.contains(e.target) &&
        btnRef.current &&
        !btnRef.current.contains(e.target)
      ) {
        setIsFilterOpen(false);
      }
    };
    document.addEventListener("keydown", onKey);
    document.addEventListener("mousedown", onClickOutside);
    return () => {
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("mousedown", onClickOutside);
    };
  }, [isFilterOpen]);
  const handleFilterClose = () => {
    setIsFilterOpen(false);
  };
  const handleLeadsClose = () => {
    setIsShowEditLead(false);
  };
  const handleAddLeadsClose = () => {
    setIsShowAddLead(false);
  };

  //------- Add Lead -------
  const addLeadFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/lead/add`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const onAddLeadSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      getListMutate();
      setIsShowAddLead(false);
    } else {
      setIsShowAddLead(false);
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onAddLeadError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: addLeadLoading, mutate: addLeadMutate } = useMutation(
    addLeadFunction,
    {
      onSuccess: onAddLeadSuccess,
      onError: onAddLeadError,
    }
  );

  //------- Edit Lead -------
  const editLeadFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/lead/edit`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const onEditLeadSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      setIsShowEditLead(false);
      setViewDetail(false);
      getListMutate();
    } else {
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onEditLeadError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: editLeadLoading, mutate: editLeadMutate } = useMutation(
    editLeadFunction,
    {
      onSuccess: onEditLeadSuccess,
      onError: onEditLeadError,
    }
  );

  const onSummaryBoxClick = (data) => {

    if (!Array.isArray(masterData)) return;

    let filteredData;
    if (data === "N")
      //New
      filteredData = masterData.filter((leads) => leads.status === 1);
    else if (data === "FU")
      //Follow Up
      filteredData = masterData.filter((leads) => leads.status === 2);
    else if (data === "VS")
      //Visit Scheduled
      filteredData = masterData.filter((leads) => leads.status === 3);
    else if (data === "C")
      //Coverted
      filteredData = masterData.filter((leads) => leads.status === 5);
    else if (data === "VD")
      //Visit Done
      filteredData = masterData.filter((leads) => leads.status === 4);
    else filteredData = masterData;
    setApiData(filteredData);
    //setFilter(data);
  };

  // const handleFilterChange = (values) => {
  //   setFilterType(values.filterType);
  //   setSearchQuery(values.searchQuery);

  // };

  // const handleClearFilters = () => {
  //   setFilterType("");
  //   setSearchQuery("");

  // };

  //------- Link Property Lead -------
  const linkPropertyLeadFunction = async (values) => {
    return await axios.post(
      `${Config.apiUrl}/lead/link/unlink/property`,
      values,
      {
        headers: {
          authorization: "Bearer" + " " + user.token,
          "Content-Type": "application/json",
        },
      }
    );
  };
  const onLinkPropertyeLeadSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      getListMutate();
    } else {
      toast.error(data?.rdata?.msg || "An Error Occured");
    }
  };

  const onLinkPropertyLeadError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: linkPropertyLoading, mutate: linkPropertyMutate } =
    useMutation(linkPropertyLeadFunction, {
      onSuccess: onLinkPropertyeLeadSuccess,
      onError: onLinkPropertyLeadError,
    });

  //------- Link Staff Lead -------
  const assignStaffLeadFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/lead/link/unlink/staff`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };
  const onAssignStaffLeadSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      getListMutate();
    } else {
      toast.error(data?.rdata?.msg || "An Error Occured");
    }
  };

  const onAssignStaffLeadError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: assignStaffLoading, mutate: assignStaffMutate } =
    useMutation(assignStaffLeadFunction, {
      onSuccess: onAssignStaffLeadSuccess,
      onError: onAssignStaffLeadError,
    });

  // Handle Assign Property from View Details
  const handleAssignProperty = (data) => {
    setSelectedTenant({
      tenantName: data?.name || '',
      tenantMobile: data?.mobile || '',
      gender: data?.gender || '',
      leadId: data?.id || '',
    });
    setShowProperty(true);
  }

  const handleRefresh = () => {
    setShowProperty(false);
    getListMutate();
  };

  //------- Delete Lead -------
  const deleteLeadFunction = async (values) => {
    return await axios.post(`${Config.apiUrl}/lead/remove`, values, {
      headers: {
        authorization: "Bearer" + " " + user.token,
        "Content-Type": "application/json",
      },
    });
  };

  const onDeleteLeadSuccess = (data) => {
    if (data?.data?.isSuccess === true) {
      toast.success(data?.data?.msg || "Success");
      getListMutate();
      setIsShowDeleteLead(false);
    } else {
      setIsShowDeleteLead(false);
      toast.error(data?.data?.msg || "An Error Occured");
    }
  };

  const onDeleteLeadError = (data) => {
    toast.error(data?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: deleteLeadLoading, mutate: deleteLeadMutate } = useMutation(
    deleteLeadFunction,
    {
      onSuccess: onDeleteLeadSuccess,
      onError: onDeleteLeadError,
    }
  );
  const handleDeleteClose = () => {
    setIsShowDeleteLead(false);
  };

  const handlePropertySelect = (property) => {
    setSelectedProperty(property);
    setFilter({
      staffFilters: '',
      sourceFilters: '',
      locationFilters: '',
    });
    // setSelectedId(null)
    dispatch(Select_Location({ id: 0, name: "All Locations", clientId: 0 }));
    setActiveFilter({ value: "", label: "", title: "" });
    setFilterValue("");
  };
  return (
    <BoxContainer>
      <BoxHead>
        <BoxTitle className="!mb-0 whitespace-nowrap">
          Leads
          <Underline />
        </BoxTitle>
        <Filters
          submitHandler={submitHandler}
          initialValues={initialValues}
          // InitialLoading={getDashboardLoading}
          setKey={setKey}
          setIsShowAddLead={setIsShowAddLead}
          user={user}
        />
      </BoxHead>

      <SideModal
        isOpen={linkProperty}
        onClose={() => setLinkProperty(false)}
      >
        <LinkUnlink
          setLinkProperty={setLinkProperty}
          linkProperty={linkProperty}
          linkPropertyLoading={linkPropertyLoading}
          linkPropertyMutate={linkPropertyMutate}
          property={propertyList}
          selectedData={selectedData}
        />
      </SideModal>

      <SideModal
        isOpen={showProperty}
        onClose={() => setShowProperty(false)}
      >
        <SelectProperty
          setIsSelectProperty={setShowProperty}
          isSelectProperty={showProperty}
          handleClose={() => { setShowProperty(false) }}
          getListMutate={handleRefresh}
          selectedTenant={selectedTenant}
          source="leads"
        />
      </SideModal>

      <SideModal
        isOpen={isAssignStaff}
        onClose={() => setIsAssignStaff(false)}
      >
        <AssignStaff
          setIsAssignStaff={setIsAssignStaff}
          isAssignStaff={isAssignStaff}
          assignStaffLoading={assignStaffLoading}
          assignStaffMutate={assignStaffMutate}
          staffList={staffList}
          selectedData={selectedData}
        />
      </SideModal>

      <SideModal
        isOpen={viewDetail}
        onClose={() => setViewDetail(false)}
      >
        <ViewLead
          setViewDetail={setViewDetail}
          setSelectedData={setSelectedData}
          selectedData={selectedData}
          setIsShowEditLead={setIsShowEditLead}
          setIsShowDeleteLead={setIsShowDeleteLead}
        />
      </SideModal>

      <SideModal
        isOpen={isShowEditLead}
        onClose={() => setIsShowEditLead(false)}
      >
        <EditLead
          editLeadLoading={editLeadLoading}
          editLeadMutate={editLeadMutate}
          handleClose={handleLeadsClose}
          selectedData={selectedData}
          setViewDetail={setViewDetail}
        />
      </SideModal>

      <SideModal
        isOpen={isShowAddLead}
        onClose={() => setIsShowAddLead(false)}
      >
        <AddLead
          key={key}
          setIsShowAddLead={setIsShowAddLead}
          isShowAddLead={isShowAddLead}
          addLeadMutate={addLeadMutate}
          handleClose={handleAddLeadsClose}
          addLeadLoading={addLeadLoading}
          property={propertyList}
        />
      </SideModal>

      {isShowDeleteLead && (
        <DeleteLead
          setIsShowDeleteLead={setIsShowDeleteLead}
          isShowDeleteLead={isShowDeleteLead}
          deleteLeadLoading={deleteLeadLoading}
          deleteLeadMutate={deleteLeadMutate}
          selectedData={selectedData}
          handleClose={handleDeleteClose}
        />
      )}

      <SideModal
        isOpen={isFilterOpen}
        onClose={() => setIsFilterOpen(false)}
      >
        <FilterModal
          setIsFilterOpen={setIsFilterOpen}
          onApplyFilter={onApplyFilter}
          selectedData={selectedData}
          handleClose={handleFilterClose}
          currentFilter={parseFilterValue(filterValue)}
          handleClearFilters={handleClearFilters}
          staffList={staffList}
        />
      </SideModal>

      {(isLoading || isRefetching) && !isFocused && (
        <SummarySkeletonLoading count={4} />
      )}
      {isFocused && summary && (
        <>
          <SummaryCards summaryData={summary} onClick={onSummaryBoxClick} />
          <FilterTableWrapper>
            <FilterWrapperWithSearch>
              <div className="flex md:space-x-4 md:flex-row flex-col md:gap-0 gap-4">
                <SearchFilterBox
                  options={searchOptions}
                  handleFilterChange={handleFilterChange}
                  handleClearFilters={handleClearFilters}
                />
                <DateRange
                  submitHandler={submitHandler}
                  defaultLabel={
                    moment(startDate).format("DD MMM YYYY") +
                    " - " +
                    moment(endDate).format("DD MMM YYYY")
                  }
                />
              </div>
              <div className="flex gap-2 justify-end items-center">
                <PropertiesFilterDropdown
                  properties={properties}
                  selectedProperty={selectedProperty}
                  onPropertySelect={handlePropertySelect}
                  placeholder="Select Property"
                  className="min-w-[200px] w-full md:w-[220px]"
                />
                <div className="relative">
                  <FilterBtn
                    ref={btnRef}
                    type="button"
                    title={activeFilter.title || "Open Filter"}
                    onClick={() => setIsFilterOpen((v) => !v)}
                  >
                    <IoFilter size={14} color="#9CA3AF" />
                    {activeFilter?.value && (
                      <span className="absolute -top-1 -right-1 h-2.5 w-2.5 rounded-full bg-yellow-500 border border-white" />
                    )}
                  </FilterBtn>
                </div>
              </div>
              {/* <DownloadBtn type="button" onClick={() => downloadReport()}>
    {isDownloading ? "Downloading..." : "Download"}
  </DownloadBtn> */}
            </FilterWrapperWithSearch>
            {!error && !isLoading && data && (
              <TableWrapper>
                <Table
                  apiData={error ? [] : apiData}
                  setSelectedData={setSelectedData}
                  setIsShowEditLead={setIsShowEditLead}
                  setLinkProperty={setLinkProperty}
                  setViewDetail={setViewDetail}
                  setIsAssignStaff={setIsAssignStaff}
                  handleAssignProperty={handleAssignProperty}
                />
                {(error || apiData?.length === 0) && !isLoading && (
                  <NotFoundModel msg={"No new leads at the moment."} />
                )}
              </TableWrapper>
            )}
          </FilterTableWrapper>
        </>
      )}
      {(isLoading || isRefetching) && <Loading />}
    </BoxContainer>
  );
};

const Filters = ({
  initialValues,
  submitHandler,
  InitialLoading,
  user,
  setKey,
  setIsShowAddLead,
}) => {
  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form>
        <FilterContainer>

          <AddBtn
            type="button"
            onClick={() => {
              setKey(moment().unix());
              setIsShowAddLead(true);
            }}
          >
            {"Add Lead"}
          </AddBtn>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

const TableWrapper = tw.div`mt-4 bg-white rounded-md `;
const AddBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-gradient-to-r from-primary-color to-[#00A0FF] hover:brightness-110 py-2.5 text-sm`;
const FilterContainer = tw.div`grid grid-cols-2 md:grid-cols-3 w-full gap-2 lg:gap-0 md:flex md:space-x-4 items-end mt-0 md:mt-0`;
const FilterBtn = tw.button`flex items-center border whitespace-nowrap border-gray-300 justify-center rounded-md px-4 cursor-pointer bg-white hover:bg-gray-200 h-10 text-sm ml-auto`;
export default Leads;
